import { useEffect, useRef, useState } from "react";
import {
  Autocomplete,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Checkbox,
  Dialog,
  DialogContent,
  Divider,
  FormControlLabel,
  FullscreenDialog,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  MultiImageMedia,
  Paper,
  ProdutoEstoqueInformacaoDialog,
  Select,
  Switch,
  Tab,
  TabPanel,
  Tabs,
  TextField,
  TextFieldMedidas,
  Tooltip,
  Typography,
} from "../../../components";
import { InputErros, PermisoesHelper, value } from "../../../helpers";
import { AddLayout } from "../../../layouts";
import {
  CestService,
  ColecoesService,
  EnderecoService,
  EnderecosEstoqueService,
  FamiliaProdutosService,
  GrupoProdutosService,
  GruposTributarioService,
  MarcasService,
  NcmService,
  notification,
  ProdutosService,
  SessionService,
  StorageService,
  SubfamiliaProdutosService,
  SubgrupoProdutosService,
  TagsService,
  UnidadeComercialService,
} from "../../../services";
import {
  formatPrecisaoFloat,
  gerarCodigoBarra,
  responseErros,
  unformatPrice,
  userLogs,
  voltar,
} from "../../../utils";
import AddGrupoProdutos from "../../grupoProdutos/addGrupoProdutos/addGrupoProdutos.view";
import {
  CopiarProdutoDialog,
  FormAnaliseAI,
  FormFiscal,
  FormFornecedor,
  FormGrade,
  FormImpostos,
  FormKit,
  FormPrecoCusto,
  HistoricoMovimentacao,
  ProdutoAplicacaoDialog,
  ProdutosSimilaresDialog,
} from "./components";
import { produtoValidator } from "./middlewares";

import shortid from "shortid";
import precificacaoValidator from "../../../components/modalPrecificacao/middlewares/precificacao.validator";
import { Produto } from "./entities";
import "./produto.css";

const produtosService = new ProdutosService();
const grupoProdutosService = new GrupoProdutosService();
const subgrupoProdutosService = new SubgrupoProdutosService();
const familiaProdutosService = new FamiliaProdutosService();
const subfamiliaProdutosService = new SubfamiliaProdutosService();
const tagsService = new TagsService();
const unidadeComercialService = new UnidadeComercialService();
const storageService = new StorageService();
const sessionService = new SessionService();
const ncmService = new NcmService();
const cestService = new CestService();
const marcasService = new MarcasService();
const colecoesService = new ColecoesService();
const enderecoService = new EnderecoService();
const gruposTributarioService = new GruposTributarioService();
const enderecosEstoqueService = new EnderecosEstoqueService();

const tipos = [
  { id: "simples", descricao: "Simples" },
  { id: "grade", descricao: "Grade" },
  { id: "kit", descricao: "Kit" },
];

let produtoEntity = {
  ativado: true,
  estoque: "0",
  fracionavel: false,
  precoCusto: "",
  tipo: tipos[0].id,
  peso: "0",
  pesoLiquido: "0",
  origemMercadoriaId: 1,
  tipoItemId: 1,
  lerPesoPorBalanca: "Não se aplica",
  unidadeComercialCompraId: 59,
  unidadeComercialVendaId: 59,
};

const AddProduto = ({ match }) => {
  const { id } = match.params;
  const [loading, setLoading] = useState(false);
  const [userLog, setUserLog] = useState({});
  const [produto, setProduto] = useState(produtoEntity);
  const listaImagensOriginalRef = useRef([]);
  // const prevStateRef = useRef(produto);
  const [configuracoes, setConfiguracoes] = useState({
    margemCalculo: "INVERSA",
  });
  const [openDialog, setOpenDialog] = useState(false);
  const [openDialogAplicacao, setOpenDialogAplicacao] = useState(false);
  const [openCopiarProdutoDialog, setOpenCopiarProdutoDialog] = useState(false);
  const [abaValue, setAbaValue] = useState(0);
  const PRECIFICACAO = produto?.tipo != "kit" ? 0 : 2;
  const KIT = produto?.tipo != "kit" ? 5 : 0;
  const FISCAL = 1;
  const IMPOSTOS = produto?.tipo != "kit" ? 2 : 3;
  const FORNECEDORES = 3;
  const GRADE = 4;
  const [listaGruposProdutos, setListaGruposProdutos] = useState([]);
  const [listaSubgruposProdutos, setListaSubgruposProdutos] = useState([]);
  const [listaFamiliasProdutos, setListaFamiliasProdutos] = useState([]);
  const [listaSubfamiliasProdutos, setListaSubfamiliasProdutos] = useState([]);
  const [listaMarcas, setListaMarcas] = useState([]);
  const [listaColecoes, setListaColecoes] = useState([]);
  const [listaTags, setListaTags] = useState([]);
  const [listaEnderecosEstoque, setListaEnderecosEstoque] = useState([]);
  const [listaUnidadesComerciais, setListaUnidadesComerciais] = useState([]);
  const [produtosSimilares, setProdutosSimilares] = useState([]);
  const [
    isCadastroGrupoProdutoDialogOpen,
    setIsCadastroGrupoProdutoDialogOpen,
  ] = useState(false);
  const [historicoMovimentacaoOpen, setHistoricoMovimentacaoOpen] =
    useState(false);
  const [historicoMovimentacaoList, setHistoricoMovimentacaoList] = useState(
    [],
  );
  const [fornecedoresRows, setFornecedoresRows] = useState([]);
  const [kitProdutos, setKitProdutos] = useState([]);
  const [gruposTributacao, setGruposTributacao] = useState([]);
  const [loadingAutoComplete, setLoadingAutoComplete] = useState(false);
  const dados = sessionService.getEmpresaAndUsuario();
  const permissoesHelper = new PermisoesHelper();
  permissoesHelper.validarPermisao("produtos-visualizar");
  const [inputErro, setInputErro] = useState([]);
  const inputErros = new InputErros(inputErro, setInputErro);
  const [produtosGradeList, setProdutosGradeList] = useState([]);
  const [movimentacaoEstoqueRows, setMovimentacaoEstoqueRows] = useState(0);
  const [movimentacaoTipo, setMovimentacaoTipo] = useState("saida");
  const [precificacaoPending, setPrecificacaoPending] = useState([]);
  const [aliquotasCopiadas, setAliquotasCopiadas] = useState([]);
  const [ncmList, setNcmList] = useState([]);
  const [tabelaCest, setTabelaCest] = useState([]);
  const [infoAnvisa, setInfoAnvisa] = useState(false);
  const [infoCombustivel, setInfoCombustivel] = useState(false);
  const [openAnvisaDialog, setOpenAnvisaDialog] = useState(false);
  const [openAnaliseAIDialog, setOpenAnaliseAIDialog] = useState(false);
  const [estados, setEstados] = useState([]);
  const [
    openProdutoEstoqueInformacaoDialog,
    setOpenProdutoEstoqueInformacaoDialog,
  ] = useState(false);
  const lerPesoPorBalancaOptions = [
    "Não se aplica",
    "Ler peso da balança",
    "Ler peso da etiqueta",
    "Ler peso da etiqueta do produto",
  ];
  const idCamposFormBasico = [
    "unidadeMedidaId",
    "grupoId",
    "generoItemId",
    "precoCompra",
    "precoMedio",
    "precoVenda",
    "estoque",
  ];
  const idCamposFormAnvisa = [
    "dataValidade",
    "dataFabricacao",
    "precoMaxConsumo",
    "numLote",
    "qtdLote",
    "agregado",
    "prodAnvisa",
    "motivoIsencao",
  ];
  const idCamposFormFiscal = [
    "origemId",
    "ncm",
    "cest",
    "porcentagemGpl",
    "porcentagemNacionalGpl",
    "codigoAnp",
    "valorPartidaGpl",
    "grupoTributacaoId",
  ];

  useEffect(() => {
    buscarConfiguracao();
    buscarUnidadesComerciais();
    buscarGruposProdutos();
    buscarSubgruposProdutos();
    buscarFamiliasProdutos();
    buscarSubfamiliasProdutos();
    buscarMarcas();
    buscarColecoes();
    buscarTags();
    buscarEnderecosEstoque();
    buscaEstados();
    buscarGruposTributario();
    if (!id) {
      produtoEntity = new Produto({
        ativado: true,
        estoque: "0",
        fracionavel: false,
        precoCusto: "",
        tipo: tipos[0].id,
        origemMercadoriaId: 1,
        tipoItemId: 1,
        lerPesoPorBalanca: "Não se aplica",
        unidadeComercialCompraId: 59,
        unidadeComercialVendaId: 59,
        imagens: [],
      });
    } else {
      buscarProduto();
    }
  }, []);

  const buscaEstados = async () => {
    const res = await enderecoService.getEstados();
    if (!res.isAxiosError) {
      setEstados(res.data);
    } else {
      responseErros(res);
    }
  };

  const buscarProduto = async () => {
    if (id) {
      setLoading(true);
      const res = await produtosService.getById(id);
      if (!res.isAxiosError) {
        const ncm = res.data.informacao.ncmId,
          cest = res.data.informacao.cestId;
        if (ncm) {
          buscarDadosNcm(ncm);
        }
        if (cest) {
          buscarDadosCest(cest);
        }
        if (res.data.grade) {
          const estoqueProdutosGrade = res.data.grade.produtos
            .map((item) => item.estoqueProduto.estoque)
            .reduce((a, b) => a + b);
          produtoEntity = new Produto({
            ...res.data.grade.produtos[0],
            ...res.data.grade,
            ...res.data.informacao,
            codigoBarra: null,
          });
          setProdutosGradeList(res.data.grade.produtos);
          produtoEntity.setHandleChangeInput(
            "estoqueAtual",
            estoqueProdutosGrade,
          );
          const imageUrls = res.data.grade.produtos
            .flatMap((p) => p.imagens || [])
            .map((img) => img.url);
          produtoEntity.setImagens(imageUrls);
          setProduto(produtoEntity);
          listaImagensOriginalRef.current = imageUrls;
        } else {
          produtoEntity = new Produto({
            ...res.data,
            ...res.data.informacao,
            insertUserId: res.data.insertUserId,
            updateUserId: res.data.updateUserId,
            produtoInformacaoId: res.data.informacao.id,
          });
          produtoEntity.setProdutoInformacaoId(res.data.informacao?.id);
          produtoEntity.setHandleChangeInput(
            "estoqueAtual",
            res.data.estoqueProduto.estoque,
          );
          const imageUrls = res.data.imagens?.map((img) => img.url) ?? [];
          produtoEntity.setImagens(imageUrls);
          listaImagensOriginalRef.current = imageUrls;
          setProduto(produtoEntity);
        }
        if (res.data.dataValidade) {
          setInfoAnvisa(true);
          produtoEntity.setIsMedicamento(true);
        }
        if (res.data.anpCodigo) {
          setInfoCombustivel(true);
          produtoEntity.setIsCombustivel(true);
        }
        inserirValoresListaTags(produtoEntity.tagsProdutos);
        if (res.data.similares.length > 0) {
          res.data.similares.forEach((similar) => {
            if (similar.produto) {
              setProdutosSimilares((prevState) => [
                ...prevState,
                {
                  ...similar.produto,
                  ...similar.produto.informacao,
                  ...similar.produto.estoqueProduto,
                },
              ]);
            }
          });
        }
        if (res.data.tipo == "kit" && res.data.kits.length > 0) {
          const kits = [];
          res.data.kits.forEach((kit) => {
            const produto = kit.produto;
            kits.push({
              ...produto,
              quantidade: kit.quantidade,
              estoqueAtual: produto.estoqueProduto.estoque,
              precoCompra: produto.informacao.precoCompra,
              precoCusto: produto.informacao.precoCusto,
              precoVenda: produto.informacao.precoVenda,
            });
            produtoEntity.addProdutosKitIds(kit.kitProdutoId, kit.quantidade);
          });
          setKitProdutos(kits);
        } else {
          setFornecedoresRows(
            res.data.fornecedores.map((fornecedor) => ({
              ...fornecedor,
              id: fornecedor.fornecedorId,
            })),
          );
        }
      } else {
        responseErros(res);
      }
      setLoading(false);
    }
  };

  function inserirValoresListaTags(listaTagsIds) {
    const tagsProdutos = listaTagsIds?.map(({ tagId }) => tagId) || [];
    produtoEntity.setProdutoTags(tagsProdutos);
    setProduto({
      ...produtoEntity,
      tagsProdutos,
    });
  }

  const handleOpenCopiarProdutoDialog = () => {
    setOpenCopiarProdutoDialog(true);
  };

  const montarPrecificacaoCopia = (produto, parametrosAliquotas) => {
    if (!parametrosAliquotas.length) return [];
    return [
      {
        produtoId: 0,
        produtoInformacaoId: null,
        precoCompra: produto.precoCompra,
        precoCusto: produto.precoCusto,
        precoMedio: produto.precoMedio,
        precoVenda: produto.precoVenda,
        precoStandard: produto.precoStandard,
        comissao: produto.comissao,
        lucroDesejado: produto.lucroDesejado,
        grupoTributacaoId: produto.grupoTributacaoId,
        ncmCodigo: produto.ncmCodigo,
        ncmId: produto.ncmId,
        cestId: produto.cestId,
        enderecoEstoqueId: produto.enderecoEstoqueId,
        aliquotas: parametrosAliquotas.map(
          ({ estParametroAliquotaId, valor }) => ({
            id: shortid.generate(),
            parametroAliquotaId: estParametroAliquotaId,
            valor,
          }),
        ),
      },
    ];
  };

  const copiarProduto = async (produtoId) => {
    if (!produtoId) return;
    setLoading(true);
    const res = await produtosService.getById(produtoId);
    if (!res.isAxiosError) {
      const { ncmId, cestId } = res.data.informacao;
      if (ncmId) buscarDadosNcm(ncmId);
      if (cestId) buscarDadosCest(cestId);
      const parametrosAliquotas = (res.data.parametrosAliquotas ?? []).map(
        ({ estParametroAliquotaId, valor }) => ({
          estParametroAliquotaId,
          valor,
        }),
      );
      produtoEntity = new Produto({
        ...res.data,
        ...res.data.informacao,
        id: null,
        codigo: null,
        codigoBarra: null,
        gtin: null,
        ativado: true,
        createdAt: null,
        updatedAt: null,
        insertUserId: null,
        updateUserId: null,
        produtoInformacaoId: null,
        estoqueAtual: 0,
        fornecedores: [],
        fracionavel: false,
        parametrosAliquotas,
      });
      produtoEntity.setImagens(res.data.imagens?.map((img) => img.url) ?? []);
      listaImagensOriginalRef.current = [];
      setFornecedoresRows([]);
      setProdutosSimilares([]);
      setAliquotasCopiadas(parametrosAliquotas);
      if (res.data.dataValidade) {
        setInfoAnvisa(true);
        produtoEntity.setIsMedicamento(true);
      }
      if (res.data.anpCodigo) {
        setInfoCombustivel(true);
        produtoEntity.setIsCombustivel(true);
      }
      inserirValoresListaTags(produtoEntity.tagsProdutos);
      setAbaValue(PRECIFICACAO);
      notification.sucessoGenericos("Produto copiado com sucesso");
    } else {
      responseErros(res);
    }
    setLoading(false);
  };

  useEffect(() => {
    sendServerDatagridMovimentacao();
  }, [movimentacaoTipo]);

  const buscarAjusteEstoque = async (filtro) => {
    const filtros = {
      estProdutoId:
        produtoEntity.tipo === "grade"
          ? produtosGradeList.map(({ id }) => id)
          : id,
      tipo: movimentacaoTipo ?? "saida",
      restritiva: true,
      ...filtro,
    };
    const result = await produtosService.getMovimentacaoEstoque(filtros);
    if (!result.isAxiosError) {
      setMovimentacaoEstoqueRows(result.data.count);
      const res = result.data?.rows.map((movimentacao) => {
        return {
          id: shortid.generate(),
          ...movimentacao,
        };
      });
      setHistoricoMovimentacaoList(res);
    } else responseErros(result);
  };

  function handleAjusteEstoqueMovimentacao() {
    buscarAjusteEstoque();
    setHistoricoMovimentacaoOpen(true);
  }

  const sendServerDatagridMovimentacao = (props) => {
    buscarAjusteEstoque(props?.filtros);
  };

  async function onClickLog() {
    if ("userCreatedLog" in userLog) return;
    const logs = await userLogs(produto);
    setUserLog(logs);
  }

  const handleCloseCadastroGrupoProduto = () => {
    buscarGruposProdutos();
    setProduto((prevState) => ({
      ...prevState,
      grupoProdutoId: null,
    }));
    setIsCadastroGrupoProdutoDialogOpen(false);
  };

  const buscarConfiguracao = () => {
    if (dados.empresa?.configuracoes) {
      const data = dados.empresa.configuracoes;
      setConfiguracoes(data);
    }
  };

  const buscarDadosNcm = async (ncmId) => {
    ncmService.getById(ncmId).then((result) => {
      if (!result.isAxiosError) {
        setNcmList([result.data]);
      } else {
        responseErros(result);
      }
    });
  };

  const buscarDadosCest = async (id) => {
    cestService.getAll({ id }).then((result) => {
      if (!result.isAxiosError) {
        setTabelaCest(result.data.rows);
      } else {
        responseErros(result);
      }
    });
  };

  const buscarGruposProdutos = () => {
    const filter = {
      nonPaginated: true,
      ativado: true,
      attributes: ['id', 'codigo', 'descricao'],
      disabledInclude: true,
    };
    grupoProdutosService.getAll(filter).then((res) => {
      if (!res.isAxiosError) {
        setListaGruposProdutos(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  const buscarGruposTributario = () => {
    const filter = {
      ativado: true,
      nonPaginated: true,
    };
    gruposTributarioService.getAll(filter).then((res) => {
      if (!res.isAxiosError) {
        setGruposTributacao(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  const buscarSubgruposProdutos = () => {
    const filter = {
      nonPaginated: true,
      ativado: true,
    };
    subgrupoProdutosService.getAll(filter).then((res) => {
      if (!res.isAxiosError) {
        setListaSubgruposProdutos(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  const buscarFamiliasProdutos = () => {
    const filter = {
      nonPaginated: true,
      ativado: true,
    };
    familiaProdutosService.getAll(filter).then((res) => {
      if (!res.isAxiosError) {
        setListaFamiliasProdutos(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  const buscarSubfamiliasProdutos = () => {
    const filter = {
      nonPaginated: true,
      ativado: true,
    };
    subfamiliaProdutosService.getAll(filter).then((res) => {
      if (!res.isAxiosError) {
        setListaSubfamiliasProdutos(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  const buscarMarcas = () => {
    const filter = {
      nonPaginated: true,
      ativado: true,
    };
    marcasService.getAll(filter).then((res) => {
      if (!res.isAxiosError) {
        setListaMarcas(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  const buscarColecoes = () => {
    const filter = {
      nonPaginated: true,
      ativado: true,
    };
    colecoesService.getAll(filter).then((res) => {
      if (!res.isAxiosError) {
        setListaColecoes(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  const buscarEnderecosEstoque = () => {
    const filter = {
      nonPaginated: true,
    };
    enderecosEstoqueService.getAll(filter).then((res) => {
      if (!res.isAxiosError) {
        setListaEnderecosEstoque(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  const buscarTags = () => {
    const filter = {
      nonPaginated: true,
      ativado: true,
      tipo: "PRODUTO",
    };
    tagsService.getAll(filter).then((res) => {
      if (!res.isAxiosError) {
        setListaTags(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  const buscarUnidadesComerciais = () => {
    unidadeComercialService.getAll().then((res) => {
      if (!res.isAxiosError) {
        setListaUnidadesComerciais(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  const handleAbaChange = (e, value) => {
    setAbaValue(value);
  };

  const handleChangeAutocomplete = (name, value) => {
    if (name == "tipo" && !value) {
      setAbaValue(PRECIFICACAO);
    }
    produtoEntity.setHandleChangeAutoComplete(name, value, tabelaCest);
    setProduto({ ...produtoEntity });
  };

  const tabProps = (index) => {
    return {
      id: `full-width-tab-${index}`,
      "aria-controls": `full-width-tabpanel-${index}`,
    };
  };

  const validarCodigoBarras = async () => {
    if (id) {
      const res = await produtosService.validarCodigoBarrasId(
        id,
        produtoEntity.codigoBarra,
      );
      if (res.isAxiosError) {
        notification.erroCadastroApi(res.response.data.message);
        setInputErro("codigoBarra");
        setLoading(false);
        return true;
      }
    } else {
      const res = await produtosService.validarCodigoBarras(
        produtoEntity.codigoBarra,
      );
      if (res.isAxiosError) {
        notification.erroCadastroApi(res.response.data.message);
        setInputErro("codigoBarra");
        setLoading(false);
        return true;
      }
    }
    return false;
  };
  async function filtrarImagens() {
    const nomeArquivos = [];
    const imagensUpload = [];

    for (const image of produto.imagens) {
      if (image && typeof image === "string" && image.startsWith("data:")) {
        imagensUpload.push(image);
      } else if (image && typeof image === "string") {
        nomeArquivos.push(image.substring(image.lastIndexOf("/") + 1));
      }
    }

    if (imagensUpload.length > 0) {
      const formData = new FormData();
      for (let i = 0; i < imagensUpload.length; i++) {
        const dataUrl = imagensUpload[i];
        const blob = await (await fetch(dataUrl)).blob();
        formData.append(
          "image",
          blob,
          `imagem-${i}-${shortid.generate()}.foto-produto`,
        );
      }
      const resStorage = await storageService.addImages(formData);
      if (!resStorage.isAxiosError && Array.isArray(resStorage.data)) {
        const documentosNomes = resStorage.data.map((item) => item.fileName);
        nomeArquivos.push(...documentosNomes);
      }
    }
    return nomeArquivos;
  }

  const validarProdutosKit = (produto) => {
    const valorTotalProdutos = kitProdutos.reduce(
      (acc, { precoVenda, quantidade }) => acc + precoVenda * quantidade,
      0,
    );
    const formatValorProdutos = Math.round(valorTotalProdutos * 100) / 100;
    const precoVendaKit = parseFloat(produto.precoVenda);
    return precoVendaKit === formatValorProdutos;
  };

  async function handleAplicarSugestaoAi(
    sugestao,
    handleClose = () => setOpenAnaliseAIDialog(false),
  ) {
    if (!sugestao) return;
    const { ncm, cest, grupoTributarioId } = sugestao;
    const [ncmEncontrado, cestEncontrado] = await Promise.all([
      ncm ? buscarNcmPorCodigo(ncm.replace(/\D/g, "").padStart(8, "0")) : null,
      cest ? buscarCestPorCodigo(cest.replace(/\D/g, "")) : null,
    ]);
    if (ncmEncontrado) produtoEntity.setProdutoNcm(ncmEncontrado);
    if (cestEncontrado) produtoEntity.setProdutoCest(cestEncontrado);
    if (grupoTributarioId) {
      produtoEntity.setProdutoGrupoTributacao(grupoTributarioId);
    }
    setProduto({ ...produtoEntity });
    handleClose();
  }

  async function buscarNcmPorCodigo(codigo) {
    const result = await buscarNcms({ codigo });
    return result?.[0] || null;
  }

  async function buscarCestPorCodigo(codigo) {
    const result = await buscarCests({ codigo });
    return result?.[0] || null;
  }

  const buscarNcms = async (filtro) => {
    const filtros = {
      ...filtro,
      limite: 20,
    };
    const result = await ncmService.getAllAvancado(filtros);
    if (!result.isAxiosError) {
      setLoadingAutoComplete(false);
      setNcmList(result.data.rows);
      if (result.data.rows?.length) return result.data.rows;
    } else {
      setLoadingAutoComplete(false);
      responseErros(result);
    }
  };

  const buscarCests = async (filtros) => {
    const filtro = {
      ...filtros,
      limite: 20,
    };
    const result = await cestService.getAll(filtro);
    if (!result.isAxiosError) {
      setLoadingAutoComplete(false);
      setTabelaCest(result.data.rows);
      if (result.data.rows?.length) return result.data.rows;
    } else {
      setLoadingAutoComplete(false);
      responseErros(result);
    }
  };

  const validarCombustivelGLP = (produtoEntity) => {
    const totalPorcentagem =
      parseFloat(produtoEntity.glp) +
      parseFloat(produtoEntity.gasNaturalNacional) +
      parseFloat(produtoEntity.gasNaturalImp);
    return formatPrecisaoFloat(totalPorcentagem) != 100.0;
  };

  const submitProduto = async (indiceSelecionado) => {
    produtoEntity.setFornecedores(fornecedoresRows);
    produtoEntity.setProdutosGrade(produtosGradeList);
    produtoEntity.setProdutosSimilaresIds(produtosSimilares);
    if (!produto.isMedicamento) produtoEntity.resetInfoAnvisa();
    if (!produto.isCombustivel) produtoEntity.resetInfoCombustivel();

    if (id && !produto.isMedicamento && infoAnvisa) {
      const retorno = await confirmarExclusaoInfoAnvisa();
      if (!retorno) return;
    }
    if (id && !produto.isCombustivel && infoCombustivel) {
      const retorno = await confirmarExclusaoInfoCombustivel();
      if (!retorno) return;
    }
    produtoValidator
      .validate(produtoEntity, { abortEarly: false })
      .then(async () => {
        setInputErro([]);
        setLoading(true);
        if (
          produtoEntity.tipo === "kit" &&
          !validarProdutosKit(produtoEntity)
        ) {
          notification.alertaApi(
            "Preço de venda do kit deve ser igual à soma da venda de seus produtos",
          );
          setLoading(false);
          return;
        }
        if (
          produtoEntity.isMedicamento &&
          produtoEntity.dataValidade &&
          produtoEntity.dataFabricacao
        ) {
          const validade = new Date(produtoEntity.dataValidade);
          const fabricacao = new Date(produtoEntity.dataFabricacao);
          if (validade < fabricacao) {
            setInputErro(["dataValidade"]);
            setAbaValue(FISCAL);
            notification.alertaApi(
              "Data de Validade deve ser após a Data de Fabricação",
            );
            setLoading(false);
            return;
          }
        }
        if (
          produtoEntity.isCombustivel &&
          produtoEntity?.anpCodigo === "210203001"
        ) {
          if (validarCombustivelGLP(produtoEntity)) {
            setInputErro(["glp", "gasNaturalNacional", "gasNaturalImp"]);
            setAbaValue(FISCAL);
            notification.alertaApi(
              "A soma das três porcentagens de GL/GN deve ser igual a 100",
            );
            setLoading(false);
            return;
          }
        }
        if (produtoEntity?.embalagem === "") {
          produtoEntity.setHandleChangeInput("embalagem", null);
        }
        if (produtoEntity?.codigoBarra) {
          if (produtoEntity.codigoBarra.replace(/\s/g, "") === "") {
            produtoEntity.setCodigoBarra(null);
          }
          const codigoRepetido = await validarCodigoBarras(produtoEntity);
          if (codigoRepetido) {
            setLoading(false);
            return;
          }
        }
        if (produtoEntity?.gtin) {
          if (produtoEntity.gtin.replace(/\s/g, "") === "") {
            produtoEntity.setGtin(null);
          }
        }
        const validarPrecos = await validarCustoVenda(produto);
        if (validarPrecos) {
          setLoading(false);
          return;
        }
        let nomesArquivos = [];
        if (produto.imagens && produto.imagens.length > 0) {
          nomesArquivos = await filtrarImagens();
        }
        const produtoBody = { ...produtoEntity };
        produtoBody.imagens = nomesArquivos.map((fileName, index) => ({
          nomeArquivo: fileName,
          ordem: index,
        }));
        if (id) {
          const imagensUrl = new Set(produto.imagens);
          const imagesDeleteStorage = listaImagensOriginalRef.current.filter(
            (originalUrl) => !imagensUrl.has(originalUrl),
          );
          if (imagesDeleteStorage.length) {
            const nomesArquivosDelete = imagesDeleteStorage.map((url) =>
              url.substring(url.lastIndexOf("/") + 1),
            );
            await Promise.all(
              nomesArquivosDelete.map((fileName) =>
                storageService.removeImage(fileName),
              ),
            );
          }
          await atualizarProduto(id, produtoBody);
        } else {
          await cadastrarProduto(produtoBody, indiceSelecionado);
        }
        setLoading(false);
      })
      .catch((err) => {
        const inputErroTemp = err?.inner?.map((item) => item.path);
        setInputErro(inputErroTemp);
        let contemErroFormBasico = false;
        let contemErroFormFiscal = false;
        let contemErroFormFornecedores = false;
        let contemErroFormGrade = false;
        let contemErroFormAnvisa = false;
        for (const erro of inputErroTemp) {
          if (idCamposFormBasico.indexOf(erro) != -1) {
            contemErroFormBasico = true;
          }
          if (idCamposFormFiscal.indexOf(erro) != -1) {
            contemErroFormFiscal = true;
          }
          if (erro == "fornecedores") {
            contemErroFormFornecedores = true;
          }
          if (erro.includes("grades")) {
            contemErroFormGrade = true;
          }
          if (idCamposFormAnvisa.indexOf(erro) != -1) {
            contemErroFormAnvisa = true;
          }
          if (
            contemErroFormBasico ||
            contemErroFormFiscal ||
            contemErroFormFornecedores ||
            contemErroFormGrade ||
            contemErroFormAnvisa
          ) {
            break;
          }
        }
        if (contemErroFormBasico) {
          setAbaValue(PRECIFICACAO);
        } else if (contemErroFormFiscal) {
          setAbaValue(FISCAL);
        } else if (contemErroFormFornecedores) {
          setAbaValue(FORNECEDORES);
        } else if (contemErroFormGrade) {
          err.errors.length = 1;
          setAbaValue(GRADE);
        } else if (contemErroFormAnvisa) {
          setAbaValue(FISCAL);
          setOpenAnvisaDialog(true);
        }
        setLoading(false);
        inputErros.set(err);
      });
  };

  const confirmarExclusaoInfoAnvisa = async () => {
    const retornoAlerta = await notification.confirmacao(
      "Atenção!",
      `Deseja excluir as informações ANVISA deste produto?`,
    );
    if (!retornoAlerta.isConfirmed) {
      produtoEntity.setIsMedicamento(true);
      setProduto({ ...produtoEntity });
      setLoading(false);
    }
    return retornoAlerta;
  };

  const confirmarExclusaoInfoCombustivel = async () => {
    const retornoAlerta = await notification.confirmacao(
      "Atenção!",
      `Deseja excluir as informações fiscais de combustível deste produto?`,
    );
    if (!retornoAlerta.isConfirmed) {
      produtoEntity.setIsCombustivel(true);
      setProduto({ ...produtoEntity });
      setLoading(false);
    }
    return retornoAlerta;
  };

  const validarCustoVenda = async (produto) => {
    if (parseFloat(produto.precoVenda) < parseFloat(produto.precoCusto)) {
      const retornoAlerta = await notification.confirmacao(
        "Atenção!",
        `Deseja salvar produto com Preço de Venda menor que Preço de Custo?`,
      );
      if (!retornoAlerta.isConfirmed) {
        setInputErro("precoVenda");
        setAbaValue(PRECIFICACAO);
        setLoading(false);
      }
      return !retornoAlerta;
    }
    return false;
  };

  const inserirPrecosKit = (data) => {
    const totalCompra = data.reduce((acc, { precoCompra, quantidade }) => {
      return formatPrecisaoFloat(acc + precoCompra * quantidade);
    }, 0);
    const totalCusto = data.reduce((acc, { precoCusto, quantidade }) => {
      return formatPrecisaoFloat(acc + precoCusto * quantidade);
    }, 0);
    const totalVenda = data.reduce((acc, { precoVenda, quantidade }) => {
      return formatPrecisaoFloat(acc + precoVenda * quantidade);
    }, 0);
    produtoEntity.setPrecos(totalCusto, totalCompra, totalVenda);
    setProduto({ ...produtoEntity });
  };

  const inserirPrecificacao = (precificacoes) => {
    produtoEntity.setPrecificacao(precificacoes[0]);
    setProduto({ ...produtoEntity });
    setPrecificacaoPending(precificacoes);
  };

  const cadastrarPrecificacaoProduto = async (produtoCadastrado) => {
    const aliquotas = precificacaoPending?.length
      ? precificacaoPending[0].aliquotas.map(
          ({ parametroAliquotaId, valor }) => ({
            estParametroAliquotaId: parametroAliquotaId,
            valor,
          }),
        )
      : aliquotasCopiadas;
    const precificacoes = montarPrecificacaoCopia(produtoEntity, aliquotas);
    if (!precificacoes.length) return true;
    const informacao =
      produtoCadastrado.informacao?.find(
        (info) => info.empresaId === dados?.empresa?.id,
      ) ?? produtoCadastrado.informacao?.[0];
    if (!produtoCadastrado.id || !informacao) return false;
    try {
      const precsToSave = precificacoes.map((p) => ({
        ...p,
        produtoId: produtoCadastrado.id,
        produtoInformacaoId: informacao.id,
      }));
      await precificacaoValidator.validate(precsToSave, {
        abortEarly: false,
      });
      const res = await produtosService.createPrecificacao(precsToSave);
      return !res.isAxiosError;
    } catch (error) {
      console.error(error);
      return false;
    }
  };

  const cadastrarProduto = async (body, indiceSelecionado) => {
    const res = await produtosService.cadastrar(body);
    setLoading(false);
    if (!res.isAxiosError) {
      const precificacaoCadastrada = await cadastrarPrecificacaoProduto(
        res.data,
      );
      if (precificacaoCadastrada) {
        notification.cadastroSucesso();
      } else {
        notification.alertaGenericos(
          "Produto cadastrado, mas os parâmetros da precificação não foram gravados. Refaça a precificação na edição do produto",
        );
      }
      resetProduto();
      if (indiceSelecionado === 0) {
        voltar();
      }
    } else {
      responseErros(res);
    }
  };

  const atualizarProduto = async (id, body) => {
    const res = await produtosService.atualizar(id, body);
    setLoading(false);
    if (!res.isAxiosError) {
      notification.alteracaoSucesso();
      resetProduto();
      voltar();
    } else {
      responseErros(res);
    }
  };

  const resetProduto = () => {
    produtoEntity = new Produto({
      ativado: true,
      estoque: "0",
      fracionavel: false,
      precoCusto: "",
      tipo: tipos[0].id,
      origemMercadoriaId: 1,
      tipoItemId: 1,
      lerPesoPorBalanca: "Não se aplica",
      unidadeComercialCompraId: 59,
      unidadeComercialVendaId: 59,
      imagens: [],
    });
    setProduto({ ...produtoEntity });
    setProdutosGradeList([]);
    setFornecedoresRows([]);
    setAliquotasCopiadas([]);
    setPrecificacaoPending([]);
    listaImagensOriginalRef.current = [];
  };

  const getMultipleAutocompleteValues = (valores, lista) => {
    if (valores) {
      return valores.map((valor) => value.autoComplete(lista, valor));
    }
    return [];
  };

  const handleInputChange = (e) => {
    produtoEntity.setHandleChangeInput(e.target.name, e.target.value);
    setProduto({ ...produtoEntity });
  };

  const handleChangeSwitch = (e) => {
    produtoEntity.setHandleChangeSwitch(e.target.name, e.target.checked);
    setProduto({ ...produtoEntity });
  };

  const handleInputEmbalagem = (e) => {
    if (!produtoEntity.fracionavel && e.data && /[^0-9]/.test(e.data)) {
      e.preventDefault();
    }
  };

  const handleInputChangeReferenciaPeca = (e) => {
    const formatted = e.target.value
      .toUpperCase()
      .replace(/[^A-Z0-9-]/g, "")
      .replace(/-{2,}/g, "-")
      .replace(/^-+/, "");
    produtoEntity.setHandleChangeInput(e.target.name, formatted);
    setProduto({ ...produtoEntity });
  };

  const handleBlurReferenciaPeca = (e) => {
    const trimmed = (e.target.value ?? "").replace(/-+$/, "");
    produtoEntity.setHandleChangeInput(e.target.name, trimmed);
    setProduto({ ...produtoEntity });
  };

  const handleChangeSwitchFracionavel = (e) => {
    const checked = e.target.checked;
    if (!checked && /[.,]/.test(produtoEntity?.embalagem)) {
      produtoEntity.setHandleChangeInput("embalagem", null);
    }
    produtoEntity.setHandleChangeSwitch(e.target.name, e.target.checked);
    setProduto({ ...produtoEntity });
  };

  const handleInputChangeVenda = (e) => {
    produtoEntity.setHandleChangeInputVenda(
      e.target.name,
      unformatPrice(e.target.value),
      id,
      configuracoes,
    );
    setProduto({ ...produtoEntity });
  };

  const handleChangeTags = (value) => {
    const tagsProdutos = value.map(({ id }) => id);
    produtoEntity.setProdutoTags(tagsProdutos);
    setProduto({
      ...produto,
      tagsProdutos,
    });
  };

  const onChangeCheckbox = (event) => {
    const { name, checked } = event.target;
    if (name === "envioKitItensFiscal" && checked) {
      produtoEntity.resetInfoFiscal();
    }
    produtoEntity.setHandleChangeSwitch(name, checked);
    setProduto((prev) => ({
      ...prev,
      ...produtoEntity,
      [name]: checked ?? null,
    }));
  };

  const openEstoqueDialog = (produtoEscolhido = produto) => {
    if (produtoEscolhido === null && !id) {
      notification.alertaGenericos("Produto não encontrado");
    } else {
      setOpenProdutoEstoqueInformacaoDialog(true);
    }
  };

  return (
    <AddLayout
      id={id}
      title={id ? "Editar produto" : "Cadastrar produto"}
      onClickSalvar={submitProduto}
      loading={loading}
      userLog={id ? userLog : null}
      onClickLog={onClickLog}
      showUpdate={permissoesHelper.temPermisao("produtos-editar")}
      codigo={id ? `Código Nº ${produto.codigo}` : null}
      actions={
        <>
          {id && (
            <IconButton
              color="padrao"
              className="mx-3"
              onClick={handleAjusteEstoqueMovimentacao}
            >
              <i className="ph-fill ph-package" style={{ fontSize: 20 }}></i>
            </IconButton>
          )}
          {!id && (
            <Tooltip title="Copiar cadastro de produto" placement="top">
              <IconButton
                color="padrao"
                className="mx-3"
                onClick={handleOpenCopiarProdutoDialog}
              >
                <i className="ph-fill ph-copy" style={{ fontSize: 20 }}></i>
              </IconButton>
            </Tooltip>
          )}
          <FormControlLabel
            control={
              <Switch
                checked={produto?.ativado}
                onChange={handleChangeSwitch}
                name="ativado"
                color="primary"
                disabled={produto?.ativado && produto?.estoqueAtual > 0}
              />
            }
            label={produto?.ativado ? "Ativado" : "Desativado"}
          />
        </>
      }
      // formState={{
      //   inicial: prevStateRef?.current,
      //   final: montarBodyProduto(),
      // }}
      resetFormFunction={resetProduto}
    >
      <Grid container>
        <Grid item xs={10}>
          <Typography variant="body2" gutterBottom sx={{ mb: 2 }}>
            {" "}
            Identificação do Produto
          </Typography>
          <Grid container spacing={2} columns={id ? 15 : 13}>
            {id ? (
              <Grid item xs={2}>
                <TextField
                  id="codigo"
                  name="codigo"
                  label="Código"
                  disabled
                  variant="outlined"
                  value={produto?.codigo ?? ""}
                  fullWidth
                />
              </Grid>
            ) : null}
            <Grid item xs={3}>
              <Autocomplete
                id="tipo"
                name="tipo"
                disabled={id}
                options={tipos}
                disableClearable
                noOptionsText="Sem opções"
                autoHighlight
                getOptionLabel={(option) => option.descricao ?? ""}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    required
                    variant="outlined"
                    label="Tipo"
                    error={inputErros.get("tipo")}
                  />
                )}
                onChange={(e, value) => handleChangeAutocomplete("tipo", value)}
                value={value.autoComplete(tipos, produto?.tipo)}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                id="descricao"
                name="descricao"
                label="Descrição"
                variant="outlined"
                value={produto?.descricao ?? ""}
                InputProps={{ inputProps: { maxLength: 50 } }}
                onChange={handleInputChange}
                error={inputErros.get("descricao")}
                required
                fullWidth
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                id="codigoBarra"
                name="codigoBarra"
                label="Código de Barra"
                variant={produto.tipo == "grade" ? "filled" : "outlined"}
                error={inputErros.get("codigoBarra")}
                disabled={produto.tipo == "grade" ? true : false}
                value={
                  produto.tipo != "grade" && produto.codigoBarra
                    ? produto.codigoBarra
                    : ""
                }
                InputProps={{
                  endAdornment: id &&
                    (configuracoes.inicialCodigoBarrasBalanca ===
                      parseInt(produto.codigoBarra) ||
                      !produto?.codigoBarra?.length) &&
                    produto?.tipo === "simples" && (
                      <InputAdornment position="end">
                        <Tooltip
                          title="Gerar código de barras"
                          arrow
                          placement="top"
                        >
                          <IconButton
                            aria-label="Gerar Código de Barras"
                            onClick={() => {
                              const codigoBarra = gerarCodigoBarra(
                                produtoEntity,
                                produto.codigoBarra,
                              );
                              produtoEntity.setCodigoBarra(codigoBarra);
                              setProduto({ ...produtoEntity });
                            }}
                          >
                            <i
                              className="ph-bold ph-barcode"
                              style={{ color: "#494C62", fontSize: 18 }}
                            ></i>
                          </IconButton>
                        </Tooltip>
                      </InputAdornment>
                    ),
                }}
                onChange={handleInputChange}
                fullWidth
              />
            </Grid>
          </Grid>
          <Divider sx={{ mt: 2, border: "1px solid grey", width: "100%" }} />
          <Grid item xs={15}>
            <Typography variant="body2" gutterBottom sx={{ mb: 2, mt: 2 }}>
              {" "}
              Classificação do Produto
            </Typography>
            <Grid container spacing={2} columns={16}>
              <Grid item xs={4}>
                <Autocomplete
                  id="grupoProdutoId"
                  name="grupoProdutoId"
                  options={listaGruposProdutos}
                  autoHighlight
                  getOptionLabel={(option) =>
                    option.codigo
                      ? `${option.codigo} - ${option.descricao}`
                      : ""
                  }
                  noOptionsText={
                    <Grid container spacing={1}>
                      <Grid item xs={7} className="mt-2" fullWidth>
                        Nenhum grupo encontrado
                      </Grid>
                      <Grid item xs={5} className="d-flex justify-content-end">
                        <Button
                          variant="outlined"
                          color="primary"
                          onClick={() =>
                            setIsCadastroGrupoProdutoDialogOpen(true)
                          }
                        >
                          Adicionar
                        </Button>
                      </Grid>
                    </Grid>
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Grupo de Produto"
                      required
                      variant="outlined"
                      error={inputErros.get("grupoProdutoId")}
                    />
                  )}
                  onChange={(e, value) =>
                    handleChangeAutocomplete("grupoProdutoId", value)
                  }
                  value={value.autoComplete(
                    listaGruposProdutos,
                    produto.grupoProdutoId,
                  )}
                />
              </Grid>
              <Grid item xs={4}>
                <Autocomplete
                  id="subgrupoProdutoId"
                  name="subgrupoProdutoId"
                  options={listaSubgruposProdutos}
                  autoHighlight
                  getOptionLabel={(option) =>
                    option.codigo
                      ? `${option.codigo} - ${option.descricao}`
                      : ""
                  }
                  noOptionsText={"Nenhum subgrupo encontrado"}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Subgrupo de Produto"
                      variant="outlined"
                      error={inputErros.get("subgrupoProdutoId")}
                    />
                  )}
                  onChange={(e, value) =>
                    handleChangeAutocomplete("subgrupoProdutoId", value)
                  }
                  value={value.autoComplete(
                    listaSubgruposProdutos,
                    produto.subgrupoProdutoId,
                  )}
                />
              </Grid>
              <Grid item xs={4}>
                <Autocomplete
                  id="familiaProdutoId"
                  name="familiaProdutoId"
                  options={listaFamiliasProdutos}
                  autoHighlight
                  getOptionLabel={(option) =>
                    option.codigo
                      ? `${option.codigo} - ${option.descricao}`
                      : ""
                  }
                  noOptionsText={"Nenhuma família encontrada"}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Família de Produto"
                      variant="outlined"
                      error={inputErros.get("familiaProdutoId")}
                    />
                  )}
                  onChange={(e, value) =>
                    handleChangeAutocomplete("familiaProdutoId", value)
                  }
                  value={value.autoComplete(
                    listaFamiliasProdutos,
                    produto.familiaProdutoId,
                  )}
                />
              </Grid>
              <Grid item xs={4}>
                <Autocomplete
                  id="subfamiliaProdutoId"
                  name="subfamiliaProdutoId"
                  options={listaSubfamiliasProdutos}
                  autoHighlight
                  getOptionLabel={(option) =>
                    option.codigo
                      ? `${option.codigo} - ${option.descricao}`
                      : ""
                  }
                  noOptionsText={"Nenhuma subfamília encontrada"}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Subfamília de Produto"
                      variant="outlined"
                      error={inputErros.get("subfamiliaProdutoId")}
                    />
                  )}
                  onChange={(e, value) =>
                    handleChangeAutocomplete("subfamiliaProdutoId", value)
                  }
                  value={value.autoComplete(
                    listaSubfamiliasProdutos,
                    produto.subfamiliaProdutoId,
                  )}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2} columns={16} sx={{ mt: 1 }}>
              <Grid item xs={4}>
                <Autocomplete
                  id="marcaId"
                  name="marcaId"
                  options={listaMarcas}
                  autoHighlight
                  getOptionLabel={(option) => option?.nome || ""}
                  noOptionsText="Sem Opções"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Marca"
                      variant="outlined"
                      error={inputErros.get("marcaId")}
                    />
                  )}
                  onChange={(e, value) =>
                    handleChangeAutocomplete("marcaId", value)
                  }
                  value={value.autoComplete(listaMarcas, produto.marcaId)}
                />
              </Grid>
              <Grid item xs={4}>
                <Autocomplete
                  id="colecaoId"
                  name="colecaoId"
                  options={listaColecoes}
                  autoHighlight
                  getOptionLabel={(option) => option?.descricao || ""}
                  noOptionsText="Sem Opções"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Coleção"
                      variant="outlined"
                      error={inputErros.get("colecaoId")}
                    />
                  )}
                  onChange={(e, value) =>
                    handleChangeAutocomplete("colecaoId", value)
                  }
                  value={value.autoComplete(listaColecoes, produto.colecaoId)}
                />
              </Grid>
              <Grid item xs={4}>
                <Autocomplete
                  multiple
                  id="tagsProdutos"
                  name="tagsProdutos"
                  options={listaTags}
                  noOptionsText="Sem opções"
                  autoHighlight
                  filterSelectedOptions
                  renderOption={(props, option) => {
                    return option ? (
                      <li {...props}>
                        <div className="d-flex align-items-center gap-2 w-100">
                          <i
                            className="ph-fill ph-bookmark-simple"
                            style={{ color: option.cor, fontSize: 18 }}
                          />
                          <div>{option.descricao}</div>
                        </div>
                      </li>
                    ) : (
                      ""
                    );
                  }}
                  getOptionLabel={(option) => {
                    return option ? option.descricao : "";
                  }}
                  onChange={(_, newValue) => handleChangeTags(newValue)}
                  value={getMultipleAutocompleteValues(
                    produto?.tagsProdutos,
                    listaTags,
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Tags"
                      error={inputErros.get("tagsProdutos")}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={4}>
                <Tooltip
                  title="Adicione aplicações para o produto"
                  placement="top"
                >
                  {" "}
                  <Button
                    disabled={produto.tipo == "grade"}
                    size="large"
                    variant="contained"
                    color="primary"
                    fullWidth
                    sx={{ height: "52px" }}
                    onClick={() => setOpenDialogAplicacao(true)}
                  >
                    Aplicação
                  </Button>
                </Tooltip>
              </Grid>
            </Grid>
            <Grid container spacing={2} columns={16} sx={{ mt: 1 }}>
              {dados?.empresa?.moduloServico && (
                <Grid item xs={4}>
                  <TextField
                    id="referenciaPeca"
                    name="referenciaPeca"
                    label="Referência da Peça"
                    variant="outlined"
                    value={produto?.referenciaPeca ?? ""}
                    InputProps={{ inputProps: { maxLength: 20 } }}
                    onChange={handleInputChangeReferenciaPeca}
                    onBlur={handleBlurReferenciaPeca}
                    error={inputErros.get("referenciaPeca")}
                    fullWidth
                  />
                </Grid>
              )}
              <Grid item xs={4}>
                <Autocomplete
                  id="enderecoEstoqueId"
                  name="enderecoEstoqueId"
                  options={listaEnderecosEstoque}
                  autoHighlight
                  getOptionLabel={(option) => option?.endereco || ""}
                  noOptionsText="Sem Opções"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Endereço de Estoque"
                      variant="outlined"
                      error={inputErros.get("enderecoEstoqueId")}
                    />
                  )}
                  onChange={(e, value) =>
                    handleChangeAutocomplete("enderecoEstoqueId", value)
                  }
                  value={value.autoComplete(
                    listaEnderecosEstoque,
                    produto.enderecoEstoqueId,
                  )}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={2} sx={{ mt: 4 }}>
          <MultiImageMedia
            useValue={produto}
            setUseValue={setProduto}
            entity={produtoEntity}
          />
        </Grid>
      </Grid>
      <Divider sx={{ mt: 2, border: "1px solid grey", width: "100%" }} />
      <Typography variant="body2" gutterBottom sx={{ mb: 2, mt: 2 }}>
        {" "}
        Estoque e Unidade
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={2.05}>
          <TextField
            id="estoque"
            name="estoque"
            label="Estoque"
            variant="filled"
            disabled
            type="number"
            InputLabelProps={{ shrink: true }}
            InputProps={{ inputProps: { min: 0 } }}
            value={
              produto?.fracionavel
                ? Math.floor(produto?.estoqueAtual * 100) / 100 ?? ""
                : produto?.estoqueAtual ?? ""
            }
            fullWidth
          />
        </Grid>
        <Grid item xs={0.45} sx={{ mt: "0.5em" }}>
          <Tooltip title="Estoque e Informação do Produto" placement="bottom">
            <Button
              id="buttonEstoqueInformacaoItem"
              variant="contained"
              color="primary"
              size="small"
              disabled={!id && dados.usuario?.acessosEmpresas?.length > 1}
              sx={{
                height: "35px",
                borderRadius: "20%",
                minWidth: "15px",
                boxShadow: "none",
              }}
              onClick={() => openEstoqueDialog()}
            >
              <i
                className="ph-fill ph-package"
                style={{ color: "#fff", fontSize: 15 }}
              ></i>
            </Button>
          </Tooltip>
        </Grid>
        <Grid item xs={2.5}>
          <TextField
            id="estoqueMinimo"
            name="estoqueMinimo"
            label="Limite de Estoque Mínimo"
            variant="outlined"
            type="number"
            InputLabelProps={{ shrink: true }}
            InputProps={
              produto?.fracionavel
                ? { inputProps: { min: 0.01, step: 0.01 } }
                : { inputProps: { min: 1, step: 1 } }
            }
            value={produto.estoqueMinimo ?? ""}
            onChange={handleInputChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={2.5}>
          <Autocomplete
            id="unidadeComercialCompraId"
            name="unidadeComercialCompraId"
            required
            options={listaUnidadesComerciais}
            noOptionsText="Sem opções"
            autoHighlight
            getOptionLabel={(option) => option.descricao ?? ""}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Unidade Comercial Compra"
                variant="outlined"
                required
                error={inputErros.get("unidadeComercialCompraId")}
              />
            )}
            onChange={(_, value) => {
              setInputErro([]);
              handleChangeAutocomplete("unidadeComercialCompraId", value);
            }}
            value={value.autoComplete(
              listaUnidadesComerciais,
              produto?.unidadeComercialCompraId,
            )}
          />
        </Grid>
        <Grid item xs={2.5}>
          <Autocomplete
            id="unidadeComercialVendaId"
            name="unidadeComercialVendaId"
            options={listaUnidadesComerciais}
            noOptionsText="Sem opções"
            autoHighlight
            required
            getOptionLabel={(option) => option.descricao ?? ""}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Unidade Comercial Venda"
                variant="outlined"
                error={inputErros.get("unidadeComercialVendaId")}
                required
              />
            )}
            onChange={(_, value) => {
              setInputErro([]);
              handleChangeAutocomplete("unidadeComercialVendaId", value);
            }}
            value={value.autoComplete(
              listaUnidadesComerciais,
              produto?.unidadeComercialVendaId,
            )}
          />
        </Grid>
        <Grid item xs={2}>
          <Tooltip title="Permitir fracionamento do produto" placement="top">
            <FormControlLabel
              label="Fracionável?"
              labelPlacement="end"
              control={
                <Checkbox
                  name="fracionavel"
                  checked={produto.fracionavel ?? false}
                  onChange={handleChangeSwitchFracionavel}
                  color="primary"
                />
              }
            />
          </Tooltip>
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ mt: 1 }}>
        <Grid item xs={2}>
          <Tooltip
            title="Define a quantidade mínima permitida para venda"
            arrow
            placement="top"
          >
            <TextField
              id="embalagem"
              name="embalagem"
              label="Embalagem"
              variant="outlined"
              type="number"
              InputLabelProps={{ shrink: true }}
              InputProps={{ inputProps: { min: 0 } }}
              value={produto.embalagem ?? ""}
              onBeforeInput={handleInputEmbalagem}
              onChange={handleInputChange}
              fullWidth
            />
          </Tooltip>
        </Grid>
        <Grid item xs={2.5}>
          <TextField
            id="conversorEntrada"
            name="conversorEntrada"
            label="Conversor de Entrada"
            variant="outlined"
            type="number"
            InputLabelProps={{ shrink: true }}
            InputProps={{ inputProps: { min: 0 } }}
            value={produto.conversorEntrada ?? ""}
            onChange={handleInputChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={3}>
          <Select
            id="lerPesoPorBalanca"
            name="lerPesoPorBalanca"
            label="Peso por Balança"
            variant="outlined"
            fullWidth
            value={produto.lerPesoPorBalanca ?? ""}
            onChange={handleInputChange}
          >
            {lerPesoPorBalancaOptions.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </Grid>
        <Grid item xs={2.5}>
          <Tooltip title="Adicione produtos similares a este" placement="top">
            <Button
              disabled={produto.tipo == "grade"}
              size="large"
              variant="contained"
              color="primary"
              fullWidth
              sx={{ height: "52px" }}
              onClick={() => setOpenDialog(true)}
            >
              Similar
            </Button>
          </Tooltip>
        </Grid>
      </Grid>
      <Divider sx={{ mt: 2, border: "1px solid grey", width: "100%" }} />
      <Typography variant="body2" gutterBottom sx={{ mb: 2, mt: 2 }}>
        {" "}
        Dimensões e Peso
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={2}>
            <TextFieldMedidas
              id="altura"
              name="altura"
              label="Altura"
              unit="cm"
              shrink
              value={produto?.altura}
              onBlur={handleInputChangeVenda}
              error={inputErros.get("altura")}
              required={produto?.hubVendas}
            />
          </Grid>
          <Grid item xs={2}>
            <TextFieldMedidas
              id="largura"
              name="largura"
              label="Largura"
              unit="cm"
              shrink
              maxValue={100}
              value={produto?.largura}
              onBlur={handleInputChangeVenda}
              error={inputErros.get("largura")}
              required={produto?.hubVendas}
            />
          </Grid>
          <Grid item xs={2}>
            <TextFieldMedidas
              id="comprimento"
              name="comprimento"
              label="Comprimento"
              unit="cm"
              shrink
              value={produto?.comprimento}
              onBlur={handleInputChangeVenda}
              error={inputErros.get("comprimento")}
              required={produto?.hubVendas}
            />
          </Grid>
          <Grid item xs={2}>
            <TextFieldMedidas
              id="peso"
              name="peso"
              label="Peso Bruto"
              unit="g"
              shrink
              decimalScale={3}
              value={produto?.peso}
              onBlur={handleInputChangeVenda}
              error={inputErros.get("peso")}
              required={produto?.hubVendas}
            />
          </Grid>
          <Grid item xs={2}>
            <TextFieldMedidas
              id="pesoLiquido"
              name="pesoLiquido"
              label="Peso Líquido"
              unit="g"
              shrink
              decimalScale={3}
              value={produto?.pesoLiquido}
              onBlur={handleInputChangeVenda}
              error={inputErros.get("pesoLiquido")}
            />
          </Grid>
          {dados.empresa?.hubVendas && (
            <Grid item xs={2}>
              <Tooltip
                title="Habilitar esse produto para o hub de vendas"
                placement="top"
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={produto?.hubVendas}
                      onChange={onChangeCheckbox}
                      name="hubVendas"
                      color="primary"
                    />
                  }
                  label="Hub Vendas"
                />
              </Tooltip>
            </Grid>
          )}
        </Grid>
      </Typography>
      <Divider sx={{ mt: 2, border: "1px solid grey", width: "100%" }} />
      <Grid container spacing={2} className="mt-4">
        <Grid item xs={12} className="mb-3">
          <span className="fw-bold fw-bolder">DETALHES DO PRODUTO</span>
        </Grid>
        <Grid item xs={12}>
          <Paper className="mb-3">
            {produto.tipo === "kit" && (
              <>
                <Tabs
                  value={abaValue}
                  onChange={handleAbaChange}
                  indicatorColor="primary"
                  textColor="primary"
                  variant="fullWidth"
                  scrollButtons="auto"
                >
                  <Tab label="Kit" {...tabProps(KIT)} />
                  <Tab label="Fiscal" {...tabProps(FISCAL)} />
                  <Tab label="Precificação" {...tabProps(PRECIFICACAO)} />
                </Tabs>
              </>
            )}
            {produto.tipo !== "kit" && (
              <>
                <Tabs
                  value={abaValue}
                  onChange={handleAbaChange}
                  indicatorColor="primary"
                  textColor="primary"
                  variant="fullWidth"
                  scrollButtons="auto"
                >
                  <Tab label="Precificação" {...tabProps(PRECIFICACAO)} />
                  <Tab label="Fiscal" {...tabProps(FISCAL)} />
                  <Tab label="Impostos" {...tabProps(IMPOSTOS)} />
                  <Tab label="Fornecedores" {...tabProps(FORNECEDORES)} />
                  {/* <Tab label="Campos Personalizados" {...tabProps(CAMPOS_PERSONALIZADOS)} /> */}
                  {produto.tipo === "grade" ? (
                    <Tab label="Grade" {...tabProps(GRADE)} />
                  ) : null}
                </Tabs>
              </>
            )}
          </Paper>
          <TabPanel value={abaValue} index={PRECIFICACAO}>
            <FormPrecoCusto
              id={id}
              produto={produto}
              inputErros={inputErros}
              handleInputChangeVenda={handleInputChangeVenda}
              configuracoes={configuracoes}
              precificacaoPending={precificacaoPending}
              inserirPrecificacao={inserirPrecificacao}
            />
          </TabPanel>
          <TabPanel value={abaValue} index={KIT}>
            <FormKit
              kitProdutos={kitProdutos}
              setKitProdutos={setKitProdutos}
              produto={produto}
              setProduto={setProduto}
              inserirPrecosKit={inserirPrecosKit}
              inputErros={inputErros}
              produtoEntity={produtoEntity}
              onChangeCheckbox={onChangeCheckbox}
            />
          </TabPanel>
          <TabPanel value={abaValue} index={FISCAL}>
            <FormFiscal
              produto={produto}
              setProduto={setProduto}
              inputErros={inputErros}
              setLoading={setLoading}
              ncmList={ncmList}
              tabelaCest={tabelaCest}
              setTabelaCest={setTabelaCest}
              loadingAutoComplete={loadingAutoComplete}
              setLoadingAutoComplete={setLoadingAutoComplete}
              handleChangeAutocomplete={handleChangeAutocomplete}
              handleInputChange={handleInputChange}
              produtoEntity={produtoEntity}
              listaUnidadesComerciais={listaUnidadesComerciais}
              openAnvisaDialog={openAnvisaDialog}
              setOpenAnvisaDialog={setOpenAnvisaDialog}
              estados={estados}
              buscarNcms={buscarNcms}
              buscarCests={buscarCests}
              gruposTributacao={gruposTributacao}
              setGruposTributacao={setGruposTributacao}
              setOpenAnaliseAIDialog={setOpenAnaliseAIDialog}
            />
          </TabPanel>
          <TabPanel value={abaValue} index={IMPOSTOS}>
            <FormImpostos
              produto={produto}
              handleChangeInput={handleInputChangeVenda}
            />
          </TabPanel>
          <TabPanel value={abaValue} index={FORNECEDORES}>
            <FormFornecedor
              fornecedoresRows={fornecedoresRows}
              setFornecedoresRows={setFornecedoresRows}
            />
          </TabPanel>
          {/* <TabPanel value={abaValue} index={CAMPOS_PERSONALIZADOS}>
            <FormCamposPersonalizados
              camposPersonalizados={camposPersonalizados}
              setCamposPersonalizados={setCamposPersonalizados}
              listaCampoPersonalizado={listaCampoPersonalizado}
              setListaCampoPersonalizado={setListaCampoPersonalizado}
            />
          </TabPanel> */}
          <TabPanel value={abaValue} index={GRADE}>
            <FormGrade
              id={id}
              setLoading={setLoading}
              produto={produto}
              setProduto={setProduto}
              produtosGradeList={produtosGradeList}
              setProdutosGradeList={setProdutosGradeList}
              buscarProduto={buscarProduto}
              produtoEntity={produtoEntity}
            />
          </TabPanel>
        </Grid>
      </Grid>
      <FullscreenDialog
        open={isCadastroGrupoProdutoDialogOpen}
        handleClose={handleCloseCadastroGrupoProduto}
        content={
          <AddGrupoProdutos
            isFullscreenDialog
            handleCloseFullscreenDialog={handleCloseCadastroGrupoProduto}
          />
        }
      />
      <HistoricoMovimentacao
        open={historicoMovimentacaoOpen}
        setOpen={setHistoricoMovimentacaoOpen}
        historicoMovimentacaoList={historicoMovimentacaoList}
        rowCount={movimentacaoEstoqueRows}
        produtosGradeList={produtosGradeList}
        filtroTipo={movimentacaoTipo}
        setFiltroTipo={setMovimentacaoTipo}
        sendServerDatagrid={sendServerDatagridMovimentacao}
      />
      <ProdutoAplicacaoDialog
        open={openDialogAplicacao}
        setOpen={setOpenDialogAplicacao}
        produtoId={id}
        produto={produto}
        setProduto={setProduto}
        produtoEntity={produtoEntity}
      />
      <ProdutoEstoqueInformacaoDialog
        produto={{ ...produto, id }}
        open={openProdutoEstoqueInformacaoDialog}
        setOpen={setOpenProdutoEstoqueInformacaoDialog}
        usuario={dados.usuario}
        handleChangeAutocompleteProduto={() => {}}
      />
      <Dialog
        disableEscapeKeyDown
        fullWidth
        maxWidth="md"
        PaperComponent="div"
        open={openDialog}
        aria-labelledby="form-dialog-title"
      >
        <DialogContent>
          <Card className="p-3">
            <CardHeader title="Produtos Similares" />
            <CardContent className="p-3">
              <ProdutosSimilaresDialog
                produtosSimilares={produtosSimilares}
                setProdutosSimilares={setProdutosSimilares}
                openDialog={openDialog}
                id={id}
              />
            </CardContent>
            <CardActions>
              <Button
                color="inherit"
                variant="contained"
                onClick={() => setOpenDialog(false)}
              >
                Fechar
              </Button>
            </CardActions>
          </Card>
        </DialogContent>
      </Dialog>
      <FormAnaliseAI
        open={openAnaliseAIDialog}
        setOpen={setOpenAnaliseAIDialog}
        descricaoProduto={produto?.descricao ?? ""}
        gruposTributacao={gruposTributacao}
        handleAplicarSugestaoAi={handleAplicarSugestaoAi}
      />
      <CopiarProdutoDialog
        open={openCopiarProdutoDialog}
        setOpen={setOpenCopiarProdutoDialog}
        handleCopiarProduto={copiarProduto}
      />
    </AddLayout>
  );
};

export default AddProduto;
